import * as oci from './oci.ts';
globalThis.oci = oci;
